import React from "react";
import { Link } from "react-router-dom";

// Semantic UI Components
import {
  Grid,
  Card,
  Message,
  List,
  Header,
  Image,
  Icon,
  Accordion
} from "semantic-ui-react";
import presignup from "../../assets/images/presignup.png";
import email from "../../assets/images/email.png";
import newmessage from "../../assets/images/newmessage.png";
import register from "../../assets/images/register.png";
import agreements from "../../assets/images/agreements.png";

class GuidePage extends React.Component {
  state = { activeIndex: null };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };
  render() {
    const { activeIndex } = this.state;
    return (
      <Grid container={true} centered={true}>
        <Grid.Column
          className="logginSeparation"
          mobile={16}
          tablet={16}
          computer={16}
        >
          <div>
            <h1 style={{ color: "#00ACC9" }}>Preguntas frecuentes</h1>
            <Accordion styled>
              <Accordion.Title
                active={activeIndex === 0}
                index={0}
                onClick={this.handleClick}
                className="accordionTitle"
              >
                <Icon name="dropdown" />
                ¿Cómo registrarse en la aplicación del laboratorio?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                Para registrarse en la aplicación del laboratorio debe iniciar
                el proceso haciendo clic &nbsp;
                <Link to="/presignup">aquí</Link>.
              </Accordion.Content>
              <Accordion.Title
                active={activeIndex === 1}
                index={1}
                onClick={this.handleClick}
              >
                <Icon name="dropdown" />
                ¿Qué necesito para registrarme?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                <Grid>
                  <Grid.Column>
                    <p>Para registrarse necesita la siguiente información:</p>
                    <List>
                      <List.Item>
                        <List.Content>
                          <List.Header>Número de identificación</List.Header>
                          <List.Description>
                            El número de su documento de identidad.
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    </List>

                    <Image id="svgImg" className="presignup" src={presignup} />
                  </Grid.Column>
                </Grid>
              </Accordion.Content>

              <Accordion.Title
                active={activeIndex === 3}
                index={3}
                onClick={this.handleClick}
              >
                <Icon name="dropdown" />
                ¿Cómo completo el registro?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 3}>
                <Grid>
                  <Grid.Column>
                    <p>
                      Para completar el registro debe ingresar la información
                      que se le solicita.
                    </p>
                    <p>Los campos marcados con * son obligatorios</p>

                    <p>
                      La contraseña debe contener de 5 a 20 caracteres. Se
                      admiten letras, números y caracteres especiales como !, @,
                      %, $, &.
                    </p>

                    <Image id="svgImg" className="register" src={register} />
                  </Grid.Column>
                </Grid>

                <Grid>
                  <Grid.Column>
                    <p>
                      Al final del formulario hay dos condiciones relacionadas
                      con la política de tratamiento de datos personales y debe
                      marcarlas para poder continuar.
                    </p>
                    <Image
                      id="svgImg"
                      className="agreements"
                      src={agreements}
                    />{" "}
                    <br />
                    <p>
                      Una vez el formulario esté correctamente diligenciado y
                      las políticas de datos personales sean aceptadas, podrá
                      presionar el botón “Registrarse” y terminar el proceso de
                      registro.
                    </p>
                  </Grid.Column>
                </Grid>
              </Accordion.Content>

              <Accordion.Title
                active={activeIndex === 2}
                index={2}
                onClick={this.handleClick}
              >
                <Icon name="dropdown" />
                ¿Qué hago una vez termino el registro?
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 2}>
                <Grid>
                  <Grid.Column>
                    <p>
                      Debe esperar a que se revise su solicitud y cuando sea
                      aprobada se le notificará por correo.
                    </p>
                    <Image id="svgImg" src={newmessage} />
                    <br />
                  </Grid.Column>
                </Grid>
              </Accordion.Content>
            </Accordion>
            <br />
            <br />
            <br />
          </div>
        </Grid.Column>
      </Grid>
    );
  }
}

export default GuidePage;
